/**
 * Optional API base URL for environments where /api/* is not proxied on the same host.
 * Set REACT_APP_API_BASE_URL at build time (e.g. https://api-dev.keybiodiversityareas.org)
 * so all relative API paths are requested from that host instead.
 * When unset, requests use relative URLs (same-origin).
 */
const API_BASE = typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')
  : ''

export function getApiUrl(url) {
  if (!url || typeof url !== 'string') return url
  if (!API_BASE) return url
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  if (url.startsWith('/')) return API_BASE + url
  return url
}

export default getApiUrl
